module.exports = __webpack_public_path__ + "static/media/shell32_21.00555c56.ico";